
import { Company } from "@/models/company";
import { AdminsService } from "@/services/admins-service";
import { IPaginationData } from "@/utils/browse/pagination-data";
import { IDataTableColumn } from "winfakt-vue-components/src/classes";
import Vue from "vue";
import { CRM } from "@/models/crm";
import { CompanyService } from "@/services/company-service";
import AppBrowsePagination from "@/components/BrowsePagination.vue";
import AppCreateCrm from "@/components/company/CompanyEditCrmCreate.vue";
import AppCompanyEditWrapper from "./CompanyEditWrapper.vue";

export default Vue.extend({
	data(){
		return{
			pagination: {
				limit: 50,
				offset: 0,
				order: "id",
				ascending: false
			} as IPaginationData,
			items: [] as CRM[],
			count: 0,
			createCrm: false
		};
	},
	props: {
		company: {
			type: Object as ()=>Company,
			required: true
		}
	},
	computed: {
		columns():IDataTableColumn[]{
			return [
				{
					name: "ID",
					property: "id",
					disableSorting: true
				},
				{
					name: "Admin",
					property: "adminId",
					print(value:number):string{
						let admin = AdminsService.admins.find(a=>a.id == value);
						if (!admin){
							return "Geen";
						}
						return admin.name;
					},
					disableSorting: true
				},
				{
					name: "Event",
					property: "asString",
					disableSorting: true,
					width: "1000px"
				},
			];
		}
	},
	watch: {
		pagination: {
			handler(){
				this.fetch();
			}
		}
	},
	methods: {
		async fetch(){
			let result = await CompanyService.getCrms(this.company.id, this.pagination);
			this.items = result.data;
			this.count = result.records;
		},
		setPage(page:number){
			this.pagination.offset = (page - 1)* this.pagination.limit;
		}
	},
	created(){
		this.fetch();
	},
	components: {
		AppBrowsePagination,
		AppCreateCrm,
		AppCompanyEditWrapper
	}
});
